import { InputNumber, Modal, Select, message } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  getReasonsListThunk,
  markPickerIssueThunk,
} from "../../../../../redux/PickerTO/Action";
import "./PickerIssueModal.css";
import { number } from "prop-types";
const { Option } = Select;
export class PickerIssueModal extends Component {
  state = {
    currBatchQty: this.props.selectedMed?.pendingQuantity ?? 0,
    currReason: null,
    runnerData: [],
  };

  componentDidUpdate = (prevProps) => {
    if (
      this.props.selectedMed?.pendingQuantity !==
      prevProps.selectedMed?.pendingQuantity
    ) {
      this.setState({
        currBatchQty: this.props.selectedMed?.pendingQuantity,
      });
    }
  };
  componentDidMount = () => {
    this.props
      .getReasonsListThunk({
        access_token: this.props.access_token,
        reasonType: "PICKER_REASON",
      })
      .then(() => {
        if (this.props.reasonsListFailure) {
          message.error(this.props.reasonsListFailure);
        } else {
          this.setState({
            runnerData: this.props.reasonsListSuccess,
          });
        }
      });
  };

  saveMissingMeds = () => {
    this.props.pageLoadToggle(true);

    let data = {
      access_token: this.props.access_token,
      history: this.props.history,
      toNumber: this.props.currTOId,
      boxNumber: this.props.currBoxNumber,
      productCode: this.props.selectedMed?.productCode,
      quantity: this.state.currBatchQty,
      reasonId: this.state.currReason,
    };

    this.props.markPickerIssueThunk(data).then(() => {
      this.props.pageLoadToggle(false);
      if (this.props.markPickerIssueFailure) {
        message.error(this.props.markPickerIssueFailure);
      } else if (this.props.markPickerIssueSuccess) {
        this.props.handleIssueMarked();
      }
    });
  };

  render() {
    let { medIssueModal, toggleMedIssueModal, selectedMed } = this.props;
    let { currBatchQty, currReason } = this.state;
    return (
      <div>
        <Modal
          title="Enter Picked Quantity"
          open={medIssueModal}
          centered
          onOk={() => this.saveMissingMeds()}
          onCancel={() => toggleMedIssueModal(false)}
          className="medIssueModal"
          okText="Submit"
          okButtonProps={{
            disabled: typeof currBatchQty !== "number" || !currReason,
          }}
        >
          <div className="issueWrapper">
            <div className="issueLabel">Issue Quantity</div>
            <div className="issueValue">
              {Number(this.props.selectedMed?.quantity) -
                Number(this.state.currBatchQty)}
            </div>
          </div>
          <div>
            <label>Picked Quantity</label>
          </div>
          <InputNumber
            // min={1}
            max={selectedMed?.quantity}
            style={{ width: "100%", marginBottom: "1em" }}
            placeholder="Add Qty"
            onChange={(value) => this.setState({ currBatchQty: value })}
            value={this.state.currBatchQty}
          />

          <Select
            showSearch
            placeholder="Select Reason"
            optionFilterProp="children"
            style={{ width: "100%" }}
            disabled={typeof currBatchQty !== "number"}
            size="large"
            value={currReason}
            onChange={(value) =>
              this.setState({
                currReason: value,
              })
            }
          >
            {this.state.runnerData?.map((i, l) => (
              <Option key={l} value={i.reasonId}>
                {i.value}
              </Option>
            ))}
          </Select>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  TOReducer: state.TOReducer,
  reasonsListSuccess: state.pickerTOReducer.reasonsListSuccess,
  reasonsListFailure: state.pickerTOReducer.reasonsListFailure,
  markPickerIssueSuccess: state.pickerTOReducer.markPickerIssueSuccess,
  markPickerIssueFailure: state.pickerTOReducer.markPickerIssueFailure,
});

const mapDispatchToProps = {
  getReasonsListThunk,
  markPickerIssueThunk,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PickerIssueModal)
);
